import {useEffect,useRef} from "react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const CustomTooltip = ({
  content,
  placement = "top",
  fallbackPlacements = ["bottom", "right"],
  children,
  className = "",
  forceShow = false,
  
  jobId
}) => {
  // Generate the id once per mounted instance instead of on every render -
  // otherwise the id (and the <Tooltip> registered under it) keeps changing
  // every time the parent re-renders, forcing react-tooltip to redo its
  // anchor/DOM registration work on every render for every tooltip on the
  // page.
  const tooltipIdRef = useRef(`tooltip-${Math.random().toString(36).substring(2, 9)}`);
  const tooltipId = tooltipIdRef.current;
   const tooltipRef = useRef(null);

// No changes needed here, your existing implementation is correct
useEffect(() => {
  if (forceShow && tooltipRef.current) {
    tooltipRef.current.open();
    
    const timer = setTimeout(() => {
      tooltipRef.current?.close();
    }, 5000);
    
    return () => clearTimeout(timer);
  }
}, [forceShow]);

  return (
    <>
      <span
        data-tooltip-id={tooltipId}
        data-tooltip-content={content}
        data-tooltip-place={placement}
        style={{ cursor: "pointer" }}
      >
        {children}
      </span>

    <Tooltip
        id={tooltipId}
        className={`custom-tooltip ${className}`}
        place={placement}
        fallbackPlacements={fallbackPlacements}
        positionStrategy="absolute"
        noArrow={false}
        ref={tooltipRef}
      />
    </>
  );
};

export default CustomTooltip;
